/* eslint-disable max-len */
import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const ReturnArrowIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 203.027 222.041"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { title ? <title>{ title }</title> : null }

      <g>
        <rect height="222.041" opacity="0" width="203.027" x="0" y="0"/>
        <path d="M203.027 153.506C203.027 112.471 175.205 84.1113 126.221 84.1113L54.0332 84.1113L20.7324 85.6152L22.666 90.5566L49.1992 67.8906L80.2441 37.5977C81.8555 35.8789 82.8223 33.8379 82.8223 31.0449C82.8223 25.459 79.0625 21.5918 73.2617 21.5918C71.0059 21.5918 68.2129 22.7734 66.3867 24.5996L3.22266 86.582C1.07422 88.623 0 91.0938 0 93.7793C0 96.3574 1.07422 98.8281 3.22266 100.869L66.3867 162.852C68.2129 164.785 71.0059 165.859 73.2617 165.859C79.0625 165.859 82.8223 161.992 82.8223 156.406C82.8223 153.613 81.8555 151.572 80.2441 149.854L49.1992 119.668L22.666 96.8945L20.7324 101.836L54.0332 103.34L127.832 103.34C164.463 103.34 183.799 123.535 183.799 152.432C183.799 181.436 164.463 202.92 127.832 202.92L103.125 202.92C97.2168 202.92 93.3496 207.217 93.3496 212.48C93.3496 217.744 97.2168 222.041 103.125 222.041L127.939 222.041C175.957 222.041 203.027 194.648 203.027 153.506Z" fill={ color } />
      </g>
    </svg>
  );
});
